function getHref(pathname: string): string {
    return pathname + window.location.search + window.location.hash;
}

export function navigateToLoaderApp(): void {
    window.location.replace(getHref('loader.html'));
}

/**
 * Very first execution of George Business code is here.
 * */
navigateToLoaderApp();
